module.exports = __webpack_public_path__ + "img/rightarrow.d989ff4f.svg";